import { render, staticRenderFns } from "./contactInfo.vue?vue&type=template&id=1d89e408&scoped=true&"
import script from "./contactInfo.vue?vue&type=script&lang=js&"
export * from "./contactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d89e408",
  null
  
)

export default component.exports